
import { cn } from '../lib/utils';
import { Checkbox } from './checkbox';
import { FormControl, FormField, FormItem, FormLabel, FormMessage, useFormContext } from './form';

export const CheckBoxField = ({
  name,
  label,
  className,
}: {
  name: string;
  label: React.ReactNode;
  className?: string;
}) => {
  const { control } = useFormContext();
  return (
    <FormField
      control={control}
      name={name}
      render={({ field }) => {
        return (
          <FormItem className={cn("", className)}>
            <div className="flex flex-row items-start gap-x-1">
              <FormControl>
                <Checkbox
                  checked={field.value}
                  onCheckedChange={field.onChange}
                />
              </FormControl>
              <div className="space-y-1 leading-none">
                <FormLabel>{label}</FormLabel>
              </div>
            </div>
            <FormMessage />
          </FormItem>
        );
      }}
    />
  );
};
